// source: User_Service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var User_message_pb = require('./User_message_pb.js');
goog.object.extend(proto, User_message_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.DeleteFileRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.DeleteFileResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.FileRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.FileResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.HealthzResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UploadFileRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UploadFileResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserEmailRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserResponseList', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserRolesResponse', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest', null, global);
goog.exportSymbol('proto.Olameter.GroupManagement.User.v1.UserUpdateRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.GroupManagement.User.v1.UserResponseList.repeatedFields_, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserResponseList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserResponseList.displayName = 'proto.Olameter.GroupManagement.User.v1.UserResponseList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.HealthzResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.HealthzResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.HealthzResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.UserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserUpdateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.UserUpdateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.UserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Olameter.GroupManagement.User.v1.UserRolesResponse.repeatedFields_, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserRolesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserRolesResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.UserRolesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UserEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UserEmailRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.UserEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UploadFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UploadFileRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.UploadFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.UploadFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.UploadFileResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.UploadFileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.FileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.FileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.FileRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.FileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.FileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.FileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.FileResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.FileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.DeleteFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.displayName = 'proto.Olameter.GroupManagement.User.v1.DeleteFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.GroupManagement.User.v1.DeleteFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.displayName = 'proto.Olameter.GroupManagement.User.v1.DeleteFileResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserResponseList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponseList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.toObject = function(includeInstance, msg) {
  var f, obj = {
usersResponsesList: jspb.Message.toObjectList(msg.getUsersResponsesList(),
    User_message_pb.UserResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponseList}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserResponseList;
  return proto.Olameter.GroupManagement.User.v1.UserResponseList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponseList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponseList}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserResult;
      reader.readMessage(value,User_message_pb.UserResult.deserializeBinaryFromReader);
      msg.addUsersResponses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserResponseList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponseList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersResponsesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      User_message_pb.UserResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserResult users_responses = 1;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserResult>}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.getUsersResponsesList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, User_message_pb.UserResult, 1));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserResult>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponseList} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.setUsersResponsesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResult}
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.addUsersResponses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.GroupManagement.User.v1.UserResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponseList} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResponseList.prototype.clearUsersResponsesList = function() {
  return this.setUsersResponsesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.HealthzResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.HealthzResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.HealthzResponse}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.HealthzResponse;
  return proto.Olameter.GroupManagement.User.v1.HealthzResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.HealthzResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.HealthzResponse}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.HealthzResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.HealthzResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.HealthzResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.HealthzResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.HealthzResponse.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && User_message_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserRequest;
  return proto.Olameter.GroupManagement.User.v1.UserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.User;
      reader.readMessage(value,User_message_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.User}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.getUser = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.User} */ (
    jspb.Message.getWrapperField(this, User_message_pb.User, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.User|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRequest} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userUpdate: (f = msg.getUserUpdate()) && User_message_pb.UserUpdate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserUpdateRequest;
  return proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserUpdate;
      reader.readMessage(value,User_message_pb.UserUpdate.deserializeBinaryFromReader);
      msg.setUserUpdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUpdate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.UserUpdate.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserUpdate user_update = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserUpdate}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.getUserUpdate = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserUpdate} */ (
    jspb.Message.getWrapperField(this, User_message_pb.UserUpdate, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserUpdate|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.setUserUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserUpdateRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.clearUserUpdate = function() {
  return this.setUserUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserUpdateRequest.prototype.hasUserUpdate = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userToDelete: (f = msg.getUserToDelete()) && User_message_pb.UserToDelete.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest;
  return proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserToDelete;
      reader.readMessage(value,User_message_pb.UserToDelete.deserializeBinaryFromReader);
      msg.setUserToDelete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserToDelete();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.UserToDelete.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserToDelete user_to_delete = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserToDelete}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.getUserToDelete = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserToDelete} */ (
    jspb.Message.getWrapperField(this, User_message_pb.UserToDelete, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserToDelete|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.setUserToDelete = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.clearUserToDelete = function() {
  return this.setUserToDelete(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserToDeleteRequest.prototype.hasUserToDelete = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
userResult: (f = msg.getUserResult()) && User_message_pb.UserResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponse}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserResponse;
  return proto.Olameter.GroupManagement.User.v1.UserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponse}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserResult;
      reader.readMessage(value,User_message_pb.UserResult.deserializeBinaryFromReader);
      msg.setUserResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.UserResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserResult user_result = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserResult}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.getUserResult = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserResult} */ (
    jspb.Message.getWrapperField(this, User_message_pb.UserResult, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserResult|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponse} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.setUserResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.clearUserResult = function() {
  return this.setUserResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserResponse.prototype.hasUserResult = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserRolesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
userRoleList: jspb.Message.toObjectList(msg.getUserRoleList(),
    User_message_pb.UserRoleResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserRolesResponse;
  return proto.Olameter.GroupManagement.User.v1.UserRolesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserRoleResult;
      reader.readMessage(value,User_message_pb.UserRoleResult.deserializeBinaryFromReader);
      msg.addUserRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserRolesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserRoleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      User_message_pb.UserRoleResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserRoleResult user_role = 1;
 * @return {!Array<!proto.Olameter.GroupManagement.User.v1.UserRoleResult>}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.getUserRoleList = function() {
  return /** @type{!Array<!proto.Olameter.GroupManagement.User.v1.UserRoleResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, User_message_pb.UserRoleResult, 1));
};


/**
 * @param {!Array<!proto.Olameter.GroupManagement.User.v1.UserRoleResult>} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.setUserRoleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Olameter.GroupManagement.User.v1.UserRoleResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRoleResult}
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.addUserRole = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Olameter.GroupManagement.User.v1.UserRoleResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserRolesResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserRolesResponse.prototype.clearUserRoleList = function() {
  return this.setUserRoleList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UserEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userEmail: (f = msg.getUserEmail()) && User_message_pb.UserEmail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UserEmailRequest;
  return proto.Olameter.GroupManagement.User.v1.UserEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserEmail;
      reader.readMessage(value,User_message_pb.UserEmail.deserializeBinaryFromReader);
      msg.setUserEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UserEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserEmail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.UserEmail.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserEmail user_email = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserEmail}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.getUserEmail = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserEmail} */ (
    jspb.Message.getWrapperField(this, User_message_pb.UserEmail, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserEmail|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest} returns this
*/
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.setUserEmail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UserEmailRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.clearUserEmail = function() {
  return this.setUserEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UserEmailRequest.prototype.hasUserEmail = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UploadFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
file: (f = msg.getFile()) && User_message_pb.FileManagement.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UploadFileRequest;
  return proto.Olameter.GroupManagement.User.v1.UploadFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.FileManagement;
      reader.readMessage(value,User_message_pb.FileManagement.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UploadFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.FileManagement.serializeBinaryToWriter
    );
  }
};


/**
 * optional FileManagement file = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.FileManagement}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.getFile = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.FileManagement} */ (
    jspb.Message.getWrapperField(this, User_message_pb.FileManagement, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.FileManagement|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest} returns this
*/
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.setFile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileRequest.prototype.hasFile = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.UploadFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
path: jspb.Message.getFieldWithDefault(msg, 3, ""),
exception: jspb.Message.getFieldWithDefault(msg, 4, ""),
fileError: (f = msg.getFileError()) && User_message_pb.FileUploadError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.UploadFileResponse;
  return proto.Olameter.GroupManagement.User.v1.UploadFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setException(value);
      break;
    case 5:
      var value = new User_message_pb.FileUploadError;
      reader.readMessage(value,User_message_pb.FileUploadError.deserializeBinaryFromReader);
      msg.setFileError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.UploadFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getException();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileError();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      User_message_pb.FileUploadError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string path = 3;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string exception = 4;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.getException = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.setException = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional FileUploadError file_error = 5;
 * @return {?proto.Olameter.GroupManagement.User.v1.FileUploadError}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.getFileError = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.FileUploadError} */ (
    jspb.Message.getWrapperField(this, User_message_pb.FileUploadError, 5));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.FileUploadError|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
*/
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.setFileError = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.UploadFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.clearFileError = function() {
  return this.setFileError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.UploadFileResponse.prototype.hasFileError = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.FileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.FileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileRequest}
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.FileRequest;
  return proto.Olameter.GroupManagement.User.v1.FileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileRequest}
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.FileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileRequest.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.FileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.FileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
file: (f = msg.getFile()) && User_message_pb.UserFile.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileResponse}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.FileResponse;
  return proto.Olameter.GroupManagement.User.v1.FileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileResponse}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new User_message_pb.UserFile;
      reader.readMessage(value,User_message_pb.UserFile.deserializeBinaryFromReader);
      msg.setFile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.FileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.FileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      User_message_pb.UserFile.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserFile file = 1;
 * @return {?proto.Olameter.GroupManagement.User.v1.UserFile}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.getFile = function() {
  return /** @type{?proto.Olameter.GroupManagement.User.v1.UserFile} */ (
    jspb.Message.getWrapperField(this, User_message_pb.UserFile, 1));
};


/**
 * @param {?proto.Olameter.GroupManagement.User.v1.UserFile|undefined} value
 * @return {!proto.Olameter.GroupManagement.User.v1.FileResponse} returns this
*/
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.setFile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.GroupManagement.User.v1.FileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.clearFile = function() {
  return this.setFile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.FileResponse.prototype.hasFile = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.DeleteFileRequest;
  return proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileRequest} returns this
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
result: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.GroupManagement.User.v1.DeleteFileResponse;
  return proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool result = 1;
 * @return {boolean}
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.prototype.getResult = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Olameter.GroupManagement.User.v1.DeleteFileResponse} returns this
 */
proto.Olameter.GroupManagement.User.v1.DeleteFileResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


goog.object.extend(exports, proto.Olameter.GroupManagement.User.v1);
